<div class="filter-time">
  <timepicker
    [ngModel]="_time"
    (ngModelChange)="onChangeTime($event)"
    [min]="_minTime"
    [max]="_maxTime"
    [showMeridian]="false"
    [minuteStep]="1">
  </timepicker>
</div>
